module.exports = __webpack_public_path__ + "img/tick_square.496ac3cf.svg";